export default __webpack_public_path__ + "static/media/dashIcon.a8ce15d5.svg";